import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, DataTable, Badge } from "@/components/primitives";
import { Input } from "@/components/ui/input";

export default function Audit() {
  const [data, setData] = useState({ items: [], total: 0 });
  const [q, setQ] = useState({ action: "", entity_type: "", actor_email: "" });
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    const params = new URLSearchParams();
    Object.entries(q).forEach(([k, v]) => v && params.set(k, v));
    params.set("limit", "200");
    const r = await api.get(`/audit-logs?${params.toString()}`);
    setData(r.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Log" subtitle="Audit Engine"
        action={<span className="mono text-xs text-hocp-textMuted">{data.total} records · immutable</span>}
      />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
        <div><label htmlFor="audit-filter-action" className="block text-[11px] uppercase tracking-wider text-hocp-textMuted mb-1">Action</label>
          <Input id="audit-filter-action" placeholder="Filter action…" value={q.action} onChange={(e) => setQ({ ...q, action: e.target.value })}
            className="bg-hocp-bgCard border-hocp-border mono text-[12px]" data-testid="audit-filter-action"/></div>
        <div><label htmlFor="audit-filter-entity" className="block text-[11px] uppercase tracking-wider text-hocp-textMuted mb-1">Entity type</label>
          <Input id="audit-filter-entity" placeholder="Entity type…" value={q.entity_type} onChange={(e) => setQ({ ...q, entity_type: e.target.value })}
            className="bg-hocp-bgCard border-hocp-border mono text-[12px]" data-testid="audit-filter-entity"/></div>
        <div><label htmlFor="audit-filter-actor" className="block text-[11px] uppercase tracking-wider text-hocp-textMuted mb-1">Actor email</label>
          <Input id="audit-filter-actor" placeholder="Actor email…" value={q.actor_email} onChange={(e) => setQ({ ...q, actor_email: e.target.value })}
            className="bg-hocp-bgCard border-hocp-border mono text-[12px]" data-testid="audit-filter-actor"/></div>
        <button onClick={load} disabled={loading} className="h-9 self-end bg-white text-black rounded text-[13px] font-medium hover:bg-zinc-200 disabled:opacity-50" data-testid="audit-apply-button">
          {loading ? "…" : "Apply filters"}
        </button>
      </div>
      <DataTable
        testid="audit-table"
        columns={[
          { key: "timestamp", label: "Time", render: (l) => <span className="mono text-hocp-textMuted text-[11px]">{new Date(l.timestamp).toLocaleString()}</span>, width: "180px" },
          { key: "action", label: "Action", render: (l) => <Badge tone="info">{l.action}</Badge> },
          { key: "actor_email", label: "Actor", mono: true },
          { key: "entity_type", label: "Entity", render: (l) => <span className="mono text-hocp-textMuted text-[11px]">{l.entity_type}{l.entity_id ? ` · ${String(l.entity_id).slice(-8)}` : ""}</span> },
          { key: "ip", label: "IP", mono: true },
        ]}
        rows={data.items}
        empty="No audit records."
      />
    </div>
  );
}
